import { useEffect, useState } from "react";

export default function ReadingProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      const current = window.scrollY;
      const percent = total > 0 ? Math.min(100, Math.max(0, (current / total) * 100)) : 0;
      setProgress(percent);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div className="fixed inset-x-0 top-0 z-[60] h-1 w-full bg-transparent" aria-hidden="true">
      <div
        className="h-full bg-primary-500 transition-[width] duration-150"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}